import { Schedule } from '@material-ui/icons';
import { Stack } from '@superdispatch/ui';
import { DescriptionItem, TextBox } from '@superdispatch/ui-lab';
import {
  BusinessHoursRowDTO,
  BusinessHoursType,
  formatBusinessHours,
} from 'shared/utils/businessHoursDisplay';

export interface ViewLoadBusinessHoursProps {
  businessHoursType?: BusinessHoursType | null;
  businessHours?: BusinessHoursRowDTO[] | null;
}

export function ViewLoadBusinessHours({
  businessHoursType,
  businessHours,
}: ViewLoadBusinessHoursProps) {
  const lines = formatBusinessHours(businessHoursType, businessHours);

  if (lines.length === 0) {
    return null;
  }

  return (
    <DescriptionItem icon={<Schedule />} label="Business Hours" wrap={true}>
      <Stack space="none">
        {lines.map((line) => (
          <TextBox key={line}>{line}</TextBox>
        ))}
      </Stack>
    </DescriptionItem>
  );
}
